import { FormControl, FormLabel, HStack, Input as ChakraInput, InputProps as ChackraInputProps, Text } from '@chakra-ui/react';
import { forwardRef, ForwardRefRenderFunction } from 'react';
import { FieldError } from 'react-hook-form';

interface IInputProps extends ChackraInputProps {
  name: string;
  label?: string;
  error?: FieldError;
  mask?: string;
  maskChar?: string;
  readonly?: boolean;
  width?: string | number;
  isRequired?: boolean;
}

const InputBase: ForwardRefRenderFunction<HTMLInputElement, IInputProps> = ({ name, label, error, mask, readonly, width, isRequired, ...rest }, ref) => (
  <FormControl isInvalid={!!error} w={width} isRequired={isRequired}>
    {!!label && (
      <FormLabel htmlFor={name} mb="0.5" onClick={e => e.stopPropagation()}>
        <HStack w="100%">
          <Text fontWeight="bold" whiteSpace="nowrap" fontSize="xs">
            {label}
          </Text>
          {!!error && (
            <Text fontSize="xs" color="red.500" whiteSpace="nowrap">
              {error.message}
            </Text>
          )}
        </HStack>
      </FormLabel>
    )}

    <ChakraInput
      id={name}
      name={name}
      variant="filled"
      size="md"
      bg="transparent"
      borderColor="#D1D1D1"
      _focus={{ borderColor: 'activeblue.500' }}
      _hover={{ borderColor: 'gray.500' }}
      readOnly={readonly}
      ref={ref}
      mask={mask}
      {...rest}
    />

    {/* {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>} */}
  </FormControl>
);

const Input = forwardRef(InputBase);

export { Input };
